import React, { FC } from 'react';
import { useI18n, useSelector } from '~Hooks';
import HandyPageWrapper from '~Scenes/Handy/Components/HandyPageWrapper';
import { Box } from '~Styles';
import SelectDeviceV2 from './SelectDeviceV2';
import SelectDevice from './SelectDevice';
import { useStorage } from '~Components/Storage';
import styled from '@emotion/styled';
import Paragraph from '~ComponentsImproved/Typography/Paragraph';
import Icon from '~ComponentsImproved/Icon';
import InfoIcon from '~Assets/icons/info.svg';

const StyledBox = styled(Box)`
  background-color: var(--colorBlueGray1100);
  border-radius: 8px;
`;

const DeviceSettings: FC = () => {
  const { i18n } = useI18n();
  const [storage] = useStorage();
  const companyFlags = useSelector((state) => state.companyFlags);

  return (
    <HandyPageWrapper pageTitle={i18n('Handy.Settings.DeviceTitle')}>
      {storage.taxComplianceDeviceId && (
        <StyledBox marginTop="small" padding="small" display="flex" alignItems="center" gap="xs">
          <Icon src={InfoIcon} height="16px" width="16px" color="var(--colorWhite)" />
          <Paragraph bottom={0} level={4} color="var(--colorWhite)">
            {i18n('Handy.Settings.SelectDevice')}
          </Paragraph>
        </StyledBox>
      )}

      {companyFlags.useNewLicenses ? <SelectDeviceV2 /> : <SelectDevice />}
    </HandyPageWrapper>
  );
};

export default DeviceSettings;
